import React from 'react';
import { Hand } from './hand';

export class Scene extends React.Component {
  componentDidMount () {
    var checkForThree = setInterval(() => {
      if (typeof THREE !== 'undefined') {
        clearInterval(checkForThree);
        this.initScene();
      }
    }, 500);
  }

  initScene () {
    var w = window.innerWidth;
    var h = window.innerHeight;
    var viewSize = h;
    var aspectRatio = w / h;

    var _viewport = {
        viewSize: viewSize,
        aspectRatio: aspectRatio,
        left: (-aspectRatio * viewSize) / 2,
        right: (aspectRatio * viewSize) / 2,
        top: viewSize / 2,
        bottom: -viewSize / 2,
        near: -1000,
        far: 1000
    }

    this.camera = new THREE.OrthographicCamera (
        _viewport.left,
        _viewport.right,
        _viewport.top,
        _viewport.bottom,
        _viewport.near,
        _viewport.far
    );

    this.scene = new THREE.Scene();
    this.scene.add(this.camera);

    this.camera.position.set(100, 100, 100);
    this.camera.lookAt(this.scene.position);

    /*
    this.mesh = new THREE.Mesh(
      new THREE.SphereBufferGeometry( 200, 16, 16 ),
      new THREE.MeshBasicMaterial( { color: 0x000000, wireframe: true } )
    );

    this.scene.add(this.mesh);
    */

    var light = new THREE.DirectionalLight( 0xffffff );
    light.position.set( 0, 1, 1 ).normalize();
    this.scene.add(light);

    this.renderer = new THREE.WebGLRenderer( {
      antialias: true,
      canvas: this.canvas,
      alpha: true
    } );

    this.renderer.setClearColor( 0x000000, 0 );
	  this.renderer.setPixelRatio( window.devicePixelRatio );
    this.renderer.setSize(w, h);
    window.scene = this.scene;
    this.renderWebGl();
    this.loadOBJLoader(() => {
      this.group = new THREE.Object3D();
      this.scene.add(this.group);
      this.hand = new Hand(this.group);
    });
  }

  renderWebGl () {
    var step = Date.now() * 0.0004;
    if(this.group) this.group.rotation.y = step;
    this.renderer.render(this.scene, this.camera);
    window.requestAnimationFrame(() => {
      this.renderWebGl();
    })
  }

  loadOBJLoader (callback) {
    var s = document.createElement("script");
    s.type = "text/javascript";
    s.src = "/OBJLoader.js";
    document.head.appendChild(s);

    var checkForLoader = setInterval(() => {
      if (typeof THREE.OBJLoader !== 'undefined') {
        clearInterval(checkForLoader);
        callback();
      }
    }, 500);
  }

  render () {
    return <canvas style={{
      'position': 'absolute',
      'left': 0,
      'right': 0,
      'width': '100vw',
      'height': '100vh'
    }} ref={canvas => this.canvas = canvas}/>;
  }
}



// WEBPACK FOOTER //
// ./src/scene/scene.js